import { Injectable, Injector } from '@angular/core';

import { Observable, of, Subject } from 'rxjs';
import { HttpService } from 'projects/core/src/public-api';
import { MailInfo } from './mail-info';


@Injectable({
    providedIn: 'root',
})
export class EmailService extends HttpService {

    protected sendSubject = new Subject<MailInfo>();

    get send$(): Observable<MailInfo> {
        return this.sendSubject.asObservable();
    }

    constructor(
        protected injector: Injector
    ) {
        super(injector);
    }

    getMail(): Observable<MailInfo> {
        const mailData: MailInfo = {
            email: 'pupa@gmail.com',
            subject: 'CV Drawings',
            message: 'Wanna print drawings',
            attachments: [{
                name: 'FirstFile.pdf',
            }, {
                name: 'SecondFile.pdf',
            }, {
                name: 'ThirdFile.pdf',
            }, {
                name: 'FifthFile.pdf',
            }]
        }
        return of(mailData)
    }

    sendMail(mailData: MailInfo){
        this.sendSubject.next(mailData);
    }
}